import { DialogActions, styled } from "@mui/material";
import { popoverName } from "../classes.js";
const PopoverActions = styled(DialogActions, {
  name: popoverName,
  slot: "PopoverActions"
})(() => ({
  flexWrap: "wrap"
}));
export {
  PopoverActions
};
//# sourceMappingURL=PopoverActions.js.map
